import { mutatorAction } from 'satcheljs';
import isNewMailToastEnabled from '../selectors/isNewMailToastEnabled';
import isNewMailSoundEnabled from '../selectors/isNewMailSoundEnabled';
import isReminderToastEnabled from '../selectors/isReminderToastEnabled';
import isReminderSoundEnabled from '../selectors/isReminderSoundEnabled';
import { getUserConfiguration } from 'owa-session-store';
export default mutatorAction('COMMIT_APP_NOTIFICATION_CHANGES_TO_USER_OPTIONS', function () {
    var userOptions = getUserConfiguration().UserOptions;
    userOptions.NewItemNotify = updateBitFlag(userOptions.NewItemNotify, 2 /* EMailToast */, isNewMailToastEnabled());
    userOptions.NewItemNotify = updateBitFlag(userOptions.NewItemNotify, 1 /* Sound */, isNewMailSoundEnabled());
    userOptions.EnableReminders = isReminderToastEnabled();
    userOptions.EnableReminderSound = isReminderSoundEnabled();
});
function updateBitFlag(base, flag, enabled) {
    // https://stackoverflow.com/questions/1436438/how-do-you-set-clear-and-toggle-a-single-bit-in-javascript
    return enabled ? base | flag : base & ~flag;
}
//# sourceMappingURL=commitChangesToUserOptions.js.map